module.exports = __webpack_public_path__ + "static/img/skm3.ad9ca3d5.jpg";